import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SHARED_DELON_MODULES } from '../shared-delon.module';
import { SHARED_ZORRO_MODULES } from '../shared-zorro.module';
import { EffectiveDisplayComponent } from './effective-display/effective-display.component';
import { LimitDisplayComponent } from './limit-display/limit-display.component';
import { TagsSelectComponent } from './tags-select/tags-select.component';
import { FixedDisplayComponent } from './fixed-display/fixed-display.component';
import { ColorPickerModule } from 'ngx-color-picker';
import {
  DatePickerComponent,
  MonthPickerComponent,
  RangePickerComponent,
  WeekPickerComponent,
  YearPickerComponent,
  TimePickerComponent
} from './date-picker';

const COMPONENTS = [
  TagsSelectComponent,
  LimitDisplayComponent,
  EffectiveDisplayComponent,
  FixedDisplayComponent,

  DatePickerComponent,
  RangePickerComponent,
  YearPickerComponent,
  MonthPickerComponent,
  WeekPickerComponent,
  TimePickerComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ColorPickerModule,
    ...SHARED_DELON_MODULES,
    ...SHARED_ZORRO_MODULES
    // WidgetFormControlsModule,
    // DynamicComponentModule
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS]
})
export class DSharedModule {}
